import axios from 'axios';
import { redirectToLogin } from './navigateToLogin';

const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
        timeout: 300000,
        headers: {
                'Content-Type': 'application/json',
        },
});

// Request Interceptor to add token to headers
axiosInstance.interceptors.request.use(
        (config) => {
                const token = sessionStorage.getItem('accessToken');

                // If the token exists, add it to the request headers
                if (token) {
                        config.headers['Authorization'] = `Bearer ${token}`;
                }

                return config;
        },
        (error) => {
                // Handle request error
                return Promise.reject(error);
        },
);

// Response Interceptor with navigation and refresh token logic
axiosInstance.interceptors.response.use(
        (response) => response, // Return response if successful
        async (error) => {
                // Check if error response is available
                if (error.response) {
                        // Handling Unauthorized error (401)
                        if (error.response.status === 401) {
                                const { logout } = await import('../redux/authSlice/authSlice');
                                const { default: store } = await import('../redux/store');
                                store.dispatch(logout());
                                redirectToLogin();
                        }

                        // Handling Forbidden error (403)
                        else if (error.response.status === 403) {
                                console.error('Forbidden access, please contact support.');
                                // window.location.href = '/unauthorized';  // Redirect to unauthorized page
                        }
                        // Handling Internal Server Error (500)
                        else if (error.response.status === 500) {
                                console.error('Server error, please try again later');
                                // window.location.href = '/error';  // Redirect to error page
                        }
                        // Handling Not Found error (404)
                        else if (error.response.status === 404) {
                                console.error('Page not found.');
                                // window.location.href = '/404';
                        }
                }
                // If there's no response (e.g., network error)
                else if (error.request) {
                        console.error('Network error, please check your connection');
                }
                // If there's an error setting up the request
                else {
                        console.error('Request error', error.message);
                }

                // Reject the promise to propagate the error to the caller
                return Promise.reject(error);
        },
);

export default axiosInstance;
